import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '@flex-design-system/fx';
import { MiniProfileHoverPopover } from '@flex-services/user-avatar';
import { DecoratorNode } from 'lexical';

class UserProfileNode extends DecoratorNode {
  constructor(userIdHash, text, key) {
    super(key);
    this.__userIdHash = userIdHash;
    this.__text = text;
  }
  static getType() {
    return "user-profile";
  }
  static clone(node) {
    return new UserProfileNode(node.__userIdHash, node.__text, node.__key);
  }
  createDOM() {
    return document.createElement("span");
  }
  updateDOM() {
    return false;
  }
  getTextContent() {
    return this.__text;
  }
  decorate() {
    return /* @__PURE__ */ jsxs(MiniProfileHoverPopover.Root, { children: [
      /* @__PURE__ */ jsx(MiniProfileHoverPopover.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(Typography, { style: { cursor: "pointer" }, weight: 700, children: this.__text }) }),
      /* @__PURE__ */ jsx(
        MiniProfileHoverPopover.Content,
        {
          side: "left",
          userIdHash: this.__userIdHash
        }
      )
    ] });
  }
  static importJSON(serializedNode) {
    const { userIdHash, text } = serializedNode;
    return $createUserProfileNode(userIdHash, text);
  }
  exportJSON() {
    return {
      type: "user-profile",
      userIdHash: this.__userIdHash,
      text: this.__text,
      version: 1
    };
  }
}
function $createUserProfileNode(userIdHash, text) {
  return new UserProfileNode(userIdHash, text);
}

export { $createUserProfileNode, UserProfileNode };
//# sourceMappingURL=UserProfileNode.mjs.map
